import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers';
import { realTimeMiddleware } from 'middlewares';
import { APP_NAME } from 'appConstants';

// hydrate initial state, this might be loaded via local storage or caching
export function configureAppStore(preloadedState = {}) {
  const store = configureStore({
    reducer: rootReducer,
    devTools: {
      name: APP_NAME,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        // https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data
        serializableCheck: {
          ignoredActions: ['thread/fetchDocumentBlob/fulfilled'],
        },
      }).concat(realTimeMiddleware),
    preloadedState,
  });

  /* eslint-disable no-process-env, no-underscore-dangle */
  /**
   * 👉 Enable HMR for redux reducers.
   * Replaces store's root-reducer with the updated root-reducer if there's
   * been any changes.
   * This will prevent the entire application from reloading and will
   * help speed up development.
   * 👉 For more info: https://redux.js.org/usage/configuring-your-store#hot-reloading
   */
  if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
  }

  return store;
}
